import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { ClipboardCheck, ChevronDown, ChevronUp } from "lucide-react";
import api from "@/lib/api";

export const GradingQueue = () => {
  const [rows, setRows] = useState([]);
  const [open, setOpen] = useState(false);
  const nav = useNavigate();
  useEffect(() => { api.get("/admin/grading-queue").then((r) => setRows(r.data || [])).catch(() => {}); }, []);

  return (
    <div className="mb-4" data-testid="grading-queue">
      <button
        onClick={() => setOpen((o) => !o)}
        className={`w-full sm:w-auto inline-flex items-center gap-2 rounded-full px-4 py-2 text-sm font-semibold border transition-colors ${rows.length ? "bg-[var(--terracotta)] text-white border-[var(--terracotta)]" : "bg-white border-[var(--border-warm)] text-zinc-700"}`}
        data-testid="grading-queue-toggle"
      >
        <ClipboardCheck size={15}/> Grade finished tests
        <span className={`rounded-full px-2 py-0.5 text-xs ${rows.length ? "bg-white/25" : "bg-zinc-100"}`} data-testid="grading-queue-count">{rows.length}</span>
        {open ? <ChevronUp size={14}/> : <ChevronDown size={14}/>}
      </button>
      {open && (
        <div className="mt-2 card-warm divide-y divide-[var(--border-warm)] max-h-[360px] overflow-auto" data-testid="grading-queue-list">
          {rows.length === 0 ? (
            <div className="p-4 text-sm text-zinc-500">Nothing to grade - all finished tests have a final result.</div>
          ) : rows.map((r) => (
            <div key={r.id} className="p-3 flex items-center justify-between gap-3 flex-wrap">
              <div className="min-w-0">
                <div className="text-sm font-semibold truncate">{r.user_name} <span className="font-normal text-zinc-500">· {r.user_email}</span></div>
                <div className="text-xs text-zinc-600 truncate">
                  {r.exam_title} · submitted {(r.submitted_at || "").slice(0, 16).replace("T", " ")} · {r.status === "submitted" ? "essays to mark" : "ready for final grade"}
                </div>
              </div>
              <button onClick={() => nav(`/admin/exam-attempts/${r.id}`)} className="btn-ink px-4 py-1.5 rounded-full text-xs font-semibold" data-testid={`grading-queue-open-${r.id}`}>
                Grade now
              </button>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};
